import { Typography } from "@mui/material";
import { DASH_PLACEHOLDER } from "../../../constants/dashPlaceholder";
import {
  formatAppointmentDateTableField,
  formatAppointmentDateTimeTableField,
} from "../../../utils/tableFormat";

interface AppointmentDateTimeFieldProps {
  startDate?: Date | null;
  endDate?: Date | null;
  timeZone: string;
}

const textStyle = {
  color: "inherit",
  fontSize: "inherit",
  fontWeight: "inherit",
};

export const AppointmentDateTimeField = ({
  startDate,
  endDate,
  timeZone,
}: AppointmentDateTimeFieldProps) => {
  if (!startDate) {
    return <Typography>{DASH_PLACEHOLDER}</Typography>;
  }
  if (!endDate) {
    return (
      <Typography sx={textStyle}>
        {`${formatAppointmentDateTableField(startDate, timeZone)} ${formatAppointmentDateTimeTableField(startDate, timeZone)}`}
      </Typography>
    );
  }
  return (
    <>
      <Typography sx={textStyle}>
        {formatAppointmentDateTableField(startDate, timeZone)}
      </Typography>
      <Typography sx={textStyle}>
        {`${formatAppointmentDateTimeTableField(startDate, timeZone)} ${DASH_PLACEHOLDER} ${formatAppointmentDateTimeTableField(endDate, timeZone)}`}
      </Typography>
    </>
  );
};
